import { render, staticRenderFns } from "./jjrinfo.vue?vue&type=template&id=1605aff0&scoped=true&"
import script from "./jjrinfo.vue?vue&type=script&lang=js&"
export * from "./jjrinfo.vue?vue&type=script&lang=js&"
import style0 from "./jjrinfo.vue?vue&type=style&index=0&id=1605aff0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1605aff0",
  null
  
)

export default component.exports